module.exports = __webpack_public_path__ + "media/images/checkout/desconto-7b1504287c15c97b86bb76e25b903e2f.png";